import { GET_PAYMENT_CONTRACTS } from '@/utils/store/actionTypes'
import { SET_PAYMENT_CONTRACTS } from '@/utils/store/mutationTypes'
import { apolloClient } from '@/utils/store'
import PaymentContracts from '@/apollo/payment_contract/PaymentContracts.graphql'
import { formatData } from '@/utils/apollo'

export default {
  /**
   * Gets the open payments
   *
   * @param commit
   * @returns {Promise<*>}
   */
  async [GET_PAYMENT_CONTRACTS] ({ commit }) {
    const response = await apolloClient(this).query({
      query: PaymentContracts
    })

    const paymentContracts = formatData(response)

    commit(SET_PAYMENT_CONTRACTS, paymentContracts.data)

    return paymentContracts.data
  }
}
